import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-project-proposal-no-contact-modal',
    templateUrl: './project-proposal-no-contact-modal.component.html',
    styleUrls: ['./project-proposal-no-contact-modal.component.css'],
    imports: [RouterLink]
})
export class ProjectProposalNoContactModalComponent {
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();
  projectClientId: string;

  constructor(
    public modal: NgbActiveModal) { }

  submit(quantity: number) {
    if(quantity === 1) {
      this.saved.emit(quantity);
    }
    this.modal.close();
  }
}
